import * as _ from 'lodash';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';

export default class PopupBagDirectiveController {
    static $inject = ['$scope', '$timeout', 'CartService', 'Session', '$state', '$rootScope', 'CheckoutService', 'cartonomyConfig'];

    constructor(scope, timeoutService, cartService, sessionService, stateService, rootScope, checkoutService, cartonomyConfig) {
        this._scope = scope;
        this._sessionService = sessionService;
        this._timeoutService = timeoutService;
        this._stateService = stateService;
        this._cartService = cartService;
        this._checkoutService = checkoutService;
        this._rootScope = rootScope;
        this._cartonomyConfig = cartonomyConfig;

        scope.show = false;
        scope.count = 0;
        scope.countHot = false;
        scope.title = '';
        scope.subTotal = 0;
        scope.items = [];
        scope.exists = false;

        scope.close = () => this._close();
        scope.viewOrder = () => this._viewOrder();
        scope.payMyTab = () => this._payMyTab();

        rootScope.$on(Constants.RootEvents.PAYMENT_STATUS_CHANGED, () => {
            this._onPaymentStatusChanged();
        });

        scope.$on(Constants.BroadcastMessages.POPUP_BAG_CHANGED, () => {
            this._updateBagState(null, true);
        });

        scope.$on(Constants.BroadcastMessages.DISPLAY_POPUP_BAG, (event, itemId) => {
            scope.show = true;
            this._updateBagState(itemId, true);
        });

        scope.$on(Constants.BroadcastMessages.TOGGLE_POPUP_BAG, () => {
            scope.countHot = false;
        });

        this._updateBagState(null, false);
        this._onPaymentStatusChanged();
    }

    _close() {
        this._scope.show = false;
        this._scope.countHot = false;
        this._rootScope.bagOpened = this._scope.show;
    }

    isCart() {
        return this._stateService.is(Constants.RoutingStates.CART);
    }

    _viewOrder() {
        if (this.isCart()) {
            this._rootScope.$broadcast(Constants.BroadcastMessages.CART_PAGE_REQUESTED);
        } else {
            this._stateService.go(Constants.RoutingStates.CART);
        }
        this._scope.close();
    }

    _payMyTab() {
        this._stateService.go(Constants.RoutingStates.CHECKOUT);
        this._scope.close();
    }

    _getOnlyMyItems(cart) {

        if (!cart || !cart.items || cart.items.length === 0) {
            return [];
        }

        return this._sessionService.loggedIn().then((loggedIn) => {
            if(!loggedIn){
                return cart.items || [];
            }else{
                return this._sessionService.getUserEmail().then((participantEmail) => {
                    if (!participantEmail) {
                        return cart.items || [];
                    }

                    return cart.items.filter(item => item.participantEmail == participantEmail);
                });
            }
        });
    }

    _emptyScope(cart) {
        this._scope.count = 0;
        this._scope.title = cart ? cart.title : '';
        this._scope.subTotal = 0;
        this._scope.items = [];
        this._scope.exists = false;
    }

    _loadScope(cart, updateHot, previousCount, itemId) {

        this._scope.title = cart.title;
        this._scope.exists = true;
        this._scope.groupPay = cart.fulfillment.paymentMethod === Constants.CartDetails.PaymentMethods.MULTIPLE;

        let highlightItem = null;
        if (this._scope.items) {
            highlightItem = this._scope.items.find(item => item.highlight);
        }

        
        let itemsForCounting = this._cartonomyConfig.externalStoreMode ? cart.items : this._getOnlyMyItems(cart);

        this._scope.items = _.map(itemsForCounting, (item) => {
            return {
                id: item.id,
                name: item.itemName,
                quantity: item.quantity,
                price: item.price,
                comment: item.comment,
                catalogProductId: item.catalogProductId,
                highlight: false
            };
        });

        if (highlightItem) {
            highlightItem = this._scope.items.find(item => item.id === highlightItem.id);
            if (highlightItem) {
                highlightItem.highlight = true;
            }
        }

        this._scope.count = _.sumBy(this._scope.items, (item) => item.quantity);
        this._scope.subTotal = _.sumBy(this._scope.items, (item) => item.quantity * item.price);

        if (updateHot && !this.isCart()) {
            this._scope.countHot = previousCount !== this._scope.count;
        }

        if (itemId) {
            let item = _.find(this._scope.items, {id: itemId});
            if (item) {
                item.highlight = true;
                this._timeoutService(() => {
                    item = _.find(this._scope.items, {id: itemId});
                    if (item) {
                        item.highlight = false;
                    }
                }, 3000);
            }
        }

        // forcing update because it mystically doesn't trigger often for this update
        scopeUtils.apply(this._scope);
    }

    async _updateBagState(itemId, updateHot) {

        const previousCount = this._scope.count;

        const cart = await this._cartService.getCart();

        if (!cart.items || !cart.items.length) {
            this._emptyScope(cart);
        } else {
            this._loadScope(cart, updateHot, previousCount, itemId);
        }
        scopeUtils.apply(this._scope);
    }

    async _onPaymentStatusChanged() {
        this._scope.paymentProvided = await this._checkoutService.paymentAuthorizedOrCaptured();
        scopeUtils.apply(this._scope);
    }
}



// WEBPACK FOOTER //
// ./src/modules/cart/directives/PopupBagDirective.js